<template>
  <div class="mb-4">
    <CitySelect
      :bottom-sheet-name="citySelectBottomSheetName"
      :is-loading="isLoading"
      only-kz-cities
      @onCitySelect="handleCitySelect"
    >
      <template #trigger>
        <i18n-t
          v-if="origCityName"
          class="text-text-neutral-primary flex items-center space-x-2 text-base font-semibold"
          keypath="specialOffer.details.ticketsFrom"
          tag="span"
        >
          <template #city>
            <span class="ml-2 font-normal">
              {{ $t('hotOffers.v2.departureFrom', { city: origCityName }) }}
            </span>
          </template>
        </i18n-t>
        <span v-else class="text-text-neutral-primary text-base font-medium">
          {{ $t('hotOffers.selectCity') }}
        </span>
      </template>
    </CitySelect>
    <EmptyResults
      v-if="offers?.length === 0 && !isLoading"
      class="mt-4"
      :title="$t('hotOffers.v2.emptyResults.title')"
      :description="$t('hotOffers.v2.emptyResults.description')"
    >
      <template #action>
        <button
          type="button"
          class="text-button-primary-default text-base font-semibold"
          @click="bottomSheet.show(citySelectBottomSheetName)"
        >
          {{ $t('hotOffers.v2.emptyResults.action') }}
        </button>
      </template>
    </EmptyResults>
  </div>
</template>

<script setup lang="ts">
  import { controllerModel, type MappedLocation } from 'shared';
  import { EmptyResults } from 'freedom-shared';

  import { CitySelect } from '@/entities/city-select';
  import type { hotOffersTypes } from '@/entities/hot-offers';

  defineProps<{
    citySelectBottomSheetName: string;
    origCityName?: string;
    isLoading: boolean;
    offers: hotOffersTypes.MappedHotOffer[];
  }>();

  const emit = defineEmits<{
    onCitySelect: [cityCode: MappedLocation];
  }>();
  const bottomSheet = controllerModel.useBottomSheet();

  const handleCitySelect = (city: MappedLocation) => {
    emit('onCitySelect', city);
  };
</script>
